import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { Chips } from "primeng/chips";
import { AppModuleShared } from "./app/app.module";
import { environment } from "./environments/environment";

// PrimeNG Chips bug: onPaste crashes when clipboardData is unavailable (e.g. programmatic paste events)
const _chipsOnPaste = Chips.prototype.onPaste;
Chips.prototype.onPaste = function (event: ClipboardEvent) {
    if (this.separator) {
        const clipboardData: DataTransfer =
            event.clipboardData ||
            (this.document?.defaultView as any)?.clipboardData;
        if (!clipboardData) return;
    }
    _chipsOnPaste.call(this, event);
};

export function getBaseUrl() {
    return document.getElementsByTagName("base")[0].href;
}

const providers = [{ provide: "BASE_URL", useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic(providers)
    .bootstrapModule(AppModuleShared)
    .catch((err) => console.log(err));
